import {useParams} from 'react-router-dom';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';
import {ActivityTimeline} from '../../../../../../../components/activity-timeline/activity-timeline';

export default function SeniorActivitySystemAdministratorOfficeScreen() {
  let {id}: {id?: string} = useParams();

  return (
    <ActivityTimeline caregiverMode={CaregiverMode.SystemAdministrator} participantUserId={id} />
  );
}
